import { render, staticRenderFns } from "./CreateCampaignSetupsHeader.vue?vue&type=template&id=74447414&scoped=true"
import script from "./CreateCampaignSetupsHeader.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSetupsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74447414",
  null
  
)

export default component.exports